import { InvitesApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const invitesApi = InvitesApi({}, '/api', axiosInstance);
